import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Loader } from 'library';
import { groupBy, map, sortBy } from 'lodash';

import JobFilterDropdown from '../JobFilterDropdown/JobFilterDropdown';

import './JobPostings.scss';

const fetchJobs = async () => {
  const postings = await axios.get('https://api.lever.co/v0/postings/hometap?mode=json');
  return postings?.data || [];
};

const JobPostings = () => {
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [filters, setFilters] = useState({
    location: 'All',
    team: 'All',
    commitment: 'All',
  });

  useEffect(() => {
    fetchJobs()
      .then((data) => {
        setJobPostings(data);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
      });
  }, []);

  const handleFilterChange = (filter) => {
    return (val) => {
      const newFilters = Object.assign({}, filters);
      newFilters[filter] = val;
      setFilters(newFilters);
    };
  };

  const filterOptions = {};
  jobPostings.forEach((job) => {
    map(job.categories, (value, category) => {
      if (filterOptions[category]) {
        if (!filterOptions[category].includes(value)) {
          filterOptions[category].push(value);
        }
      } else {
        filterOptions[category] = [value];
      }
    });
  });

  const filteredJobs = jobPostings.filter((job) => {
    const categories = job.categories;
    const locMatch = filters.location === 'All' || filters.location === categories.location;
    const typeMatch = filters.commitment === 'All' || filters.commitment === categories.commitment;
    const teamMatch = filters.team === 'All' || filters.team === categories.team;
    return locMatch && typeMatch && teamMatch;
  });

  const getTeam = (job) => job.categories.team;
  const groupedJobs = groupBy(sortBy(filteredJobs, getTeam), getTeam);

  return (
    <div className="JobPostings">
      {jobPostings.length > 10 && (
        <div className="JobPostingFilters">
          <p>Filter By</p>
          <JobFilterDropdown
            value={filters.location}
            options={filterOptions.location}
            label="Location"
            onChange={handleFilterChange('location')}
          />
          <JobFilterDropdown
            value={filters.team}
            options={filterOptions.team}
            label="Team"
            onChange={handleFilterChange('team')}
          />
          <JobFilterDropdown
            value={filters.commitment}
            options={filterOptions.commitment}
            label="Work Type"
            onChange={handleFilterChange('commitment')}
          />
        </div>
      )}

      {jobPostings.length > 0 ? (
        map(groupedJobs, (teamJobs, teamName) => {
          return (
            <div className="JobPostingGroup" key={teamName}>
              <h2>{teamName}</h2>
              {teamJobs.map((job) => {
                return (
                  <div className="JobPostingItem" key={job.id}>
                    <div className="JobPostingContent">
                      <a href={job.hostedUrl} rel="noopener noreferrer" target="_blank">
                        <h3>{job.text}</h3>
                      </a>
                      <p>
                        {job.categories.location}&emsp;{job.categories.commitment}
                      </p>
                    </div>
                    <Button size="small" theme="outlined" href={job.applyUrl}>
                      &emsp;Apply&emsp;
                    </Button>
                  </div>
                );
              })}
            </div>
          );
        })
      ) : (
        <div className="JobPostingEmpty">
          {loading ? (
            <Loader />
          ) : error ? (
            <div>
              Looks like we’re having some trouble fetching this data.{' '}
              <div>
                <br />
                <a href="https://jobs.lever.co/hometap" target="_blank" rel="noreferrer">
                  Click here to view open roles.
                </a>
              </div>
            </div>
          ) : (
            <span>We're sorry, there are no open positions at this time. Please check back soon!</span>
          )}
        </div>
      )}
    </div>
  );
};

export default JobPostings;
